import { Pipe, PipeTransform } from '@angular/core';
import { StatusFilaIntegracao as Status } from '../../enum/StatusFilaIntegracao';

@Pipe({
  name: 'badgeStatusFilaIntegracao',
})
export class BadgeStatusFilaIntegracaoPipe implements PipeTransform {
  transform(status: Status): string {
    const statuses = {
      [Status.NaFila]: 'secondary',
      [Status.EmExecucao]: 'primary',
      [Status.FalhaNaComunicacao]: 'danger',
      [Status.IntegradoCriticaNoProvedor]: 'warning text-dark',
      [Status.IntegradoAguardandoRespostaDoProvedor]: 'primary',
      [Status.IntegradoMovimentacaoAceita]: 'success',
      [Status.IntegradoMovimentacaoRecusada]: 'danger',
      [Status.EnvioProgramado]: 'primary',
      [Status.EnvioCancelado]: 'danger',
    };

    return statuses[status];
  }
}
